import { Col, Icon, Row, Typography } from "@visa/vds"
import { FileHelper } from "_helpers/FileHelper"
import { GlobalAlertContext } from "context/GlobalAlertContext"
import React, { useContext, useRef, useState } from "react"
import { useController } from "react-hook-form"
import { trackPromise } from "react-promise-tracker"
import { ceritificationPackageService } from "services/certification.certificationPackage"
import CertificationPackageDialog from "./CertificationPackageDialog"
import Tooltip from "rc-tooltip/lib/Tooltip"
import { renderFootnote } from "pages/GettingStarted/Components/GettingStartedQuestionnaire"
import { GETTING_STARTED_FOOTNOTES } from "_constants/CertificationTestingConstants"

const CertificationPackageCompanyRequiredDocuments = ({ packageBid, control, packageId, isReadOnly, reset, getValues, hasVisaSecureProductProviderAgreement }) => {

    const { field } = useController({
        control,
        name: "certificationPackagePageRequiredDocuments",
    });

    const [deleteDialog, setDeleteDialog] = useState(false)
    const alertContext = useContext(GlobalAlertContext);
    const [currentDocument, setCurrentDocument] = useState(null);
    const fileSelectors = [] // unable to useRef in a callback, manual assignment
    fileSelectors[0] = useRef(null)
    fileSelectors[1] = useRef(null)
    fileSelectors[2] = useRef(null)
    fileSelectors[3] = useRef(null)

    const selectFile = (idx) => {
        fileSelectors[idx].current.click();
    };

    const handleFileUpload = async (event, document, idx) => {
        let files = event.target.files
        if (files.length > 0) {
            const fileName = files[0].name
            if (files[0].size / (1024 * 1024) > 10) {
                alertContext.setErrorMessage(`${files[0].name} is more than 10MB.`)
                return
            } else if (fileName.length > 255) {
                alertContext.setErrorMessage(`${files[0].name} is more than 255 characters.`)
                return
            } else if (!["docx", "doc", "pdf"].includes(fileName.split('.').pop())) {
                alertContext.setErrorMessage(`${files[0].name} file type is not supported.`)
                return
            } else if (files[0].size == 0) {
                alertContext.setErrorMessage(`${files[0].name} is empty.`);
                return
            }

            let copiedField = [...field.value]
            copiedField[idx] = {
                footnote: document.footnote,
                requirementName: document.requirementName,
                requirement: document.requirement,
                fileName: files[0].name,
                fileDataLocal: files[0],
                fileData: await FileHelper.ConvertFileToBase64(
                    files[0]
                ),
                hasFile: true
            }
            reset({
                ...getValues(),
                certificationPackagePageRequiredDocuments: copiedField
            })
        }
    };

    const handleDeleteUpload = () => {
        let copiedField = [...field.value]
        copiedField[currentDocument.idx] = {
            requirementName: currentDocument.document.requirementName,
            requirement: currentDocument.document.requirement,
            fileName: null,
            hasFile: false
        }
        reset({
            ...getValues(),
            certificationPackagePageRequiredDocuments: copiedField
        })
        setDeleteDialog(false)
    }

    const downloadFile = (requirementId) => {
        trackPromise(
            ceritificationPackageService.GetCertificationPackageDocument(packageBid, packageId, requirementId)
        ).then((response) => {
            FileHelper.DownloadFile(response)
        })
            .catch(_ => alertContext.setErrorMessage("Unable to download document"))
    }

    const downloadLocalFile = (idx) => {
        let file = field.value[idx]
        FileHelper.DownloadUnsavedFile(file.fileName, file.fileDataLocal)
    }

    return (
        <>
            <Row className="padding-top-20px">
                <Col className="padding-bottom-0px">
                    <Typography>Required Documents</Typography>
                </Col>
            </Row>

            <CertificationPackageDialog dialogType="warning" open={deleteDialog} setOpen={setDeleteDialog} title="Warning"
                leftButton={{ color: "secondary", text: "Delete", handleClick: () => handleDeleteUpload() }}
                rightButton={{ color: "primary", text: "Close" }} >
                This action will delete &nbsp; <b>{currentDocument && currentDocument.document && currentDocument.document.fileName}</b>
            </CertificationPackageDialog>

            <Row className="padding-top-0px">
                <Col className="padding-top-0px">
                    <Row className="certification-package-required-documents-box-shadow">
                        {field && field.value && field.value.map((document, idx) =>
                            <Row key={idx} className={`certification-package-required-documents-row ${idx % 2 !== 0 ? "certification-package-required-documents-background-color-grey" : ""}`}>
                                <Col>
                                    <Row className="getting-started-remark">
                                        <span className="certification-package-required-documents-title">{document.requirementName}</span>
                                        {document.footnote > 0 && <Tooltip
                                            // @ts-ignore
                                            overlay={renderFootnote(GETTING_STARTED_FOOTNOTES[document.footnote])}
                                            placement="left" trigger={["hover", "focus"]}>
                                            <Icon className="icon-vsts getting-started-required-icon" name="info" resolution="low" aria-label="info" />
                                        </Tooltip>
                                        }
                                    </Row>

                                </Col>
                                <Col className="certification-package-required-documents-delete-file">
                                    {!document.hasFile && document.requirementName === "Visa Secure Product Provider Agreement" && hasVisaSecureProductProviderAgreement ? (
                                        <div>
                                            <p>Requirement already met</p>
                                        </div>
                                    ) : document.hasFile ?
                                        <div className="certification-package-required-documents-row">
                                            <div className="certification-package-required-documents-file-name cursor-pointer"
                                                onClick={document.fileDataLocal ? () => downloadLocalFile(idx) : () => downloadFile(document.requirement)}>
                                                {document.fileName}
                                            </div>
                                            {!isReadOnly &&
                                                <div>

                                                    <Icon
                                                        className="cursor-pointer"
                                                        name="delete"
                                                        onClick={() => {
                                                            setCurrentDocument({ document: document, idx: idx })
                                                            setDeleteDialog(true)
                                                        }}
                                                        resolution="low"
                                                        aria-label="delete"
                                                    />
                                                </div>
                                            }
                                        </div>
                                        :
                                        <>
                                            {!isReadOnly &&
                                                <>
                                                    <Icon
                                                        className="cursor-pointer"
                                                        name="file-upload"
                                                        resolution="low"
                                                        aria-label="file upload"
                                                        onClick={() => selectFile(idx)} />
                                                    <input
                                                        name={"Hello"}
                                                        accept={".docx,.doc,.pdf,"}
                                                        onChange={(e) => handleFileUpload(e, document, idx)}
                                                        ref={fileSelectors[idx]}
                                                        type="file"
                                                        style={{ display: "none" }}
                                                    />
                                                </>
                                            }
                                        </>
                                    }
                                </Col>
                            </Row >
                        )}
                    </Row>
                </Col>
            </Row>

        </>
    )
}

export default CertificationPackageCompanyRequiredDocuments